import React, { Component } from "react";
import PropTypes from "prop-types";

import { Input } from "../generic/Input";

import "./lexileSearch.less";

const MAX_LEXILE = 1440;
const MIN_LEXILE = 0;

class LexileSearch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			valueLow: this.getLowLexile(props.currentLexile),
			valueHigh: this.getHighLexile(props.currentLexile),
		};
		this.props.setLower(this.state.valueLow);
		this.props.setUpper(this.state.valueHigh);
		this.handleChangeUpper = this.handleChangeUpper.bind(this);
		this.handleChangeLower = this.handleChangeLower.bind(this);
		this.getHighLexile = this.getHighLexile.bind(this);
		this.getLowLexile = this.getLowLexile.bind(this);
	}

	getLowLexile(currentLexile) {
		let lowLexile = currentLexile - 100;
		return lowLexile < MIN_LEXILE ? MIN_LEXILE : lowLexile;
	}

	getHighLexile(currentLexile) {
		let highLexile = currentLexile + 50;
		return highLexile > MAX_LEXILE ? MAX_LEXILE : highLexile;
	}

	handleChange(event, callback) {
		let value = parseInt(event.target.value, 10);
		this.setState({ [event.target.name]: value });
		callback(value);
	}
	handleChangeUpper(event) {
		this.handleChange(event, this.props.setUpper);
	}
	handleChangeLower(event) {
		this.handleChange(event, this.props.setLower);
	}

	render() {
		return (
			<div className="lexile-input">
				<div className="lexile-search">
					<Input name="valueLow" value={this.state.valueLow} onChange={this.handleChangeLower} max={MAX_LEXILE} min={MIN_LEXILE} /> to
					<Input name="valueHigh" value={this.state.valueHigh} onChange={this.handleChangeUpper} max={MAX_LEXILE} min={MIN_LEXILE} />
				</div>
				<div className="validation-warning">{this.props.showWarning && "Invalid Lexile range (0 - 1440)"}</div>
			</div>
		);
	}
}

LexileSearch.propTypes = {
	currentLexile: PropTypes.number,
	setUpper: PropTypes.func,
	setLower: PropTypes.func,
	showWarning: PropTypes.bool
};
LexileSearch.defaultProps = {
	setUpper: () => {},
	setLower: () => {},
	showWarning: false
};
export default LexileSearch;
export {MAX_LEXILE, MIN_LEXILE};



// WEBPACK FOOTER //
// ./src/react/views/readingLevel/LexileSearch.jsx